import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import { clearToken } from '../api';

// Centralized hub for all admin sections. Landing page after logging in.
function AdminMenu() {
  const navigate = useNavigate();

  const handleLogout = () => {
    clearToken();
    navigate('/login');
  };

  const sections = [
    {
      to: '/artikler/admin',
      title: 'Artikler',
      description: 'Skriv, rediger og publiser artikler. Generer utkast fra YouTube-videoer med AI.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10l6 6v10a2 2 0 01-2 2z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 13h6M9 17h6M9 9h2" />
        </svg>
      )
    },
    {
      to: '/admin/annonser',
      title: 'Annonser',
      description: 'Legg til og prioriter annonser som vises på forsiden og inne i artikler.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
        </svg>
      )
    },
    {
      to: '/admin/ladekurver',
      title: 'Ladekurver',
      description: 'Last opp CSV og publiser interaktive ladekurver (kW + strøm mot ladenivå).',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3v18h18" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 13l3-4 3 3 4-6" />
        </svg>
      )
    },
    {
      to: '/admin',
      title: 'Bil-tester',
      description: 'Registrer nye rekkeviddetester (bilmodell, vær, temperatur, resultat).',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 17l4 4 4-4m-4-5v9" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.88 18.09A5 5 0 0018 9h-1.26A8 8 0 103 16.29" />
        </svg>
      )
    },
    {
      to: '/manage',
      title: 'Administrer bil-data',
      description: 'Rediger eller slett eksisterende testdata.',
      icon: (
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
        </svg>
      )
    }
  ];

  return (
    <div className="min-h-screen bg-slate-900 pt-8 pb-16 px-4">
      <SEO title="Admin-meny" path="/admin/meny" noindex />
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-10">
          <div>
            <h1 className="text-3xl sm:text-4xl font-bold text-white">Admin</h1>
            <p className="text-sm text-gray-400 mt-1">Velg hva du vil gjøre.</p>
          </div>
          <button
            onClick={handleLogout}
            className="px-4 py-2 bg-slate-800 text-gray-300 rounded-xl hover:bg-slate-700 transition-colors text-sm"
          >
            Logg ut
          </button>
        </div>

        {/* Grid of admin sections */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {sections.map(section => (
            <Link
              key={section.to}
              to={section.to}
              className="group block bg-slate-800 bg-opacity-60 border border-slate-700 rounded-2xl p-6 hover:border-teal-500 hover:border-opacity-60 transition-colors"
            >
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-xl bg-teal-500 bg-opacity-15 text-teal-400 flex items-center justify-center flex-shrink-0 group-hover:bg-opacity-25 transition-colors">
                  {section.icon}
                </div>
                <div className="flex-1 min-w-0">
                  <h2 className="text-lg font-bold text-white group-hover:text-teal-400 transition-colors">
                    {section.title}
                  </h2>
                  <p className="text-sm text-gray-400 mt-1 leading-relaxed">
                    {section.description}
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AdminMenu;
